// extracted by mini-css-extract-plugin
module.exports = {"title":"SubscriptionSuccess-module--title--3KiAb","description":"SubscriptionSuccess-module--description--30nyK"};